export default "__VITE_ASSET__DS373lqA__"